/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".footer[_ngcontent-%COMP%]   .info-content[_ngcontent-%COMP%]   .info-copyright[_ngcontent-%COMP%]{font-size:13px;font-weight:300}"];
export { styles as styles };
